<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableOne
      :diasNoLaboradoTipoOne="diasNoLaboradoTipoOne"
      :readOnly="readOnly"
    />
    <span class="title">{{ titleTwo }}</span>
    <TableTwo
      :diasNoLaboradoOtroTipo="diasNoLaboradoOtroTipo"
      :readOnly="readOnly"
    />
    <span class="title">{{ titleThree }}</span>
    <TableThree
      :permisoNoRemunerado="permisoNoRemunerado"
      :readOnly="readOnly"
    />
  </div>
</template>

<script>
import TableOne from "./components/mainTableFive/TableOne";
import TableTwo from "./components/mainTableFive/TableTwo";
import TableThree from "./components/mainTableFive/TableThree.vue";
export default {
  components: {
    TableOne,
    TableTwo,
    TableThree,
  },
  props: [
    "diasNoLaboradoTipoOne",
    "diasNoLaboradoOtroTipo",
    "permisoNoRemunerado",
    "readOnly",
  ],
  data() {
    return {
      //Primary Table
      titleOne:
        "5.1 Promedio mensual de días no trabajados por funcionario, por concepto de licencias médicas Tipo 1",

      //Second Table
      titleTwo:
        "5.2 Promedio mensual de días no trabajados por funcionario, por concepto de licencias médicas otro tipo",

      //Third Table
      titleThree:
        "5.3 Promedio mensual de días no trabajados por funcionario, por concepto de permisos sin goce de remuneraciones",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
